// tslint:disable-next-line:no-submodule-imports
import { faChevronLeft } from '@fortawesome/free-solid-svg-icons/faChevronLeft';
// tslint:disable-next-line:no-submodule-imports
import { faChevronRight } from '@fortawesome/free-solid-svg-icons/faChevronRight';
import React from 'react';
import { css, styled } from '../../../../common/common.styles';
import { insetInline } from '../../../../common/styles/general/logical-properties';
import { LazyFaIcon } from '../../icon/general/lazy-fa-icon';

const controlHeight = 72;

export const BaseCarouselControl = styled.div`
  width: 40px;
  height: ${controlHeight}px;
  color: ${(p) => p.theme.color.base[100]};
  text-align: center;
  line-height: ${controlHeight}px;
  font-size: ${(p) => p.theme.fontSize.large}px;
  cursor: pointer;
  background-color: ${(p) => p.theme.color.base[900]};
  z-index: 1;
  & .fa-chevron-right,
  .fa-chevron-left {
    padding-top: calc(${controlHeight / 2}px - ${(p) => p.theme.fontSize.large / 2}px);
  }
`;

export const PositionedLeftCarouselControl = styled(BaseCarouselControl)`
  ${insetInline(0, 'auto')};
`;

export const PositionedRightCarouselControl = styled(BaseCarouselControl)`
  ${insetInline('auto', 0)};
`;

interface CustomCarouselControlProps extends React.HTMLAttributes<HTMLOrSVGElement> {
  icon: JSX.Element;
}

const defaultLeftIcon: JSX.Element = <LazyFaIcon icon={faChevronLeft} />;

export function LeftLightCarouselControl({
  icon = defaultLeftIcon,
  ...props
}): React.FunctionComponentElement<CustomCarouselControlProps> {
  return (
    <PositionedLeftCarouselControl {...props} className={props.className}>
      {icon}
    </PositionedLeftCarouselControl>
  );
}

const defaultRightIcon: JSX.Element = <LazyFaIcon icon={faChevronRight} />;

export function RightLightCarouselControl({
  icon = defaultRightIcon,
  ...props
}): React.FunctionComponentElement<CustomCarouselControlProps> {
  return (
    <PositionedRightCarouselControl {...props} className={props.className}>
      {icon}
    </PositionedRightCarouselControl>
  );
}

export const TransparentArrowStyles = css`
  background-color: transparent;
  font-size: ${(p) => p.theme.fontSize.extraLarge}px;
  height: 2em;
  & .fa-chevron-right,
  .fa-chevron-left {
    padding-top: 0.5em;
  }
`;

export const TransparentPrevArrow = styled(LeftLightCarouselControl)`
  ${TransparentArrowStyles};
`;

export const TransparentNextArrow = styled(RightLightCarouselControl)`
  ${TransparentArrowStyles};
`;

export const DotsStyling = css`
  & .slick-dots {
    display: flex;
    width: 100%;
    justify-content: center;
    flex-wrap: wrap;

    > li {
      list-style: none;
    }
  }
`;

export const SlideDotStyling = css`
  border-radius: 50%;
  cursor: pointer;
`;
